import { createGetTextResources } from "../../shared/utils/text-resources-algemeen";

export const confirmButtonTextResources = createGetTextResources({
  TryAgain: "Importeren mislukt. Probeer nogmaals.",
  Save: "Dossier importeren",
  Busy: "Bezig met importeren",
  SaveSucces: "Er zijn geen wijzigingen"
});
